module.exports = __webpack_public_path__ + "static/img/app.cef8e99d.png";